<template lang="">
  <BButton
    v-if="canResetPaymentPassword"
    variant="outline-danger"
    :size="inList ? 'sm' : ''"
    @click="handleResetPaymentPassword"
  >
    <span class="">{{ $t(`myAccount.paymentPassword.reset${inList ? 'Short' : ''}`) }}</span>
  </BButton>
</template>
<script>
import { computed } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue'
import Vue from 'vue'

import store from '@/store'
import { apiEmployee } from '@/api'

import useToast from '@useToast'

export default {
  components: {
    BButton,
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
    inList: {
      type: Boolean,
      default: false,
    },
    parentAgencyId: {
      type: Number,
      default: null,
    },
  },
  setup(props, { root }) {
    const getMeDataType = computed(() => store.getters['userStore/getMeDataType'])
    const isRoleF1 = computed(() => store.getters['userStore/getRoleMama'])
    const getMeDataId = computed(() => store.getters['userStore/getMeDataId'])
    const getAgencyDataId = computed(() => store.getters['userStore/getAgencyDataId'])

    const { toastError } = useToast()

    const canResetPaymentPassword = computed(() => {
      const employeeType = props.employee?.type
      const employeeId = props.employee?.id
      // employee phải bật MKTT
      if (!props.employee?.enablePaymentPassword) return false

      // ADM F1: được update tất cả user && OPE F1: được update tất cả user trừ ADM và OPE khác F1
      if (
        (getMeDataType.value === 'ADM' || (getMeDataType.value === 'OPE' && !['ADM', 'OPE'].includes(employeeType)))
        && isRoleF1.value
      ) return true
      // OTHER F1: được update tất cả cấp dưới và chính nó
      if (employeeId === getMeDataId.value) return true
      return [props.employee.agency?.parentAgency?.id, props.employee.agency?.id, props?.parentAgencyId]
        .some(id => id === getAgencyDataId.value)
    })

    function handleResetPaymentPassword() {
      this.$bvModal
        .msgBoxConfirm(this.$t('myAccount.paymentPassword.resetConfirm'), {
          title: this.$t('modal.confirm'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('modal.yes'),
          cancelTitle: this.$t('modal.no'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.$bvModal.show('modal-api-loading')
            apiEmployee.resetPaymentPassword(props.employee.id)
              .then(async res => {
                await store.dispatch('userStore/fetchMeData')
                const { username, newPassword } = res
                Vue.swal({
                  title: this.$t('messagesList.success'),
                  html: `
                  <div class="text-20px font-weight-bolder">
                    ${this.$t('myAccount.paymentPassword.updateSuccess')}
                    <div class="text-16px">
                      ${this.$t('myAccount.paymentPassword.newPasswordMessage', { username, newPassword })}
                    </div>
                  </div>`,
                  icon: 'success',
                  showCancelButton: true,
                  showConfirmButton: true,
                  allowEscapeKey: true,
                  allowOutsideClick: false,
                  cancelButtonText: this.$t('close'),
                  confirmButtonText: this.$t('copy'),
                  customClass: {
                    title: 'text-20px font-weight-bolder text-success',
                    cancelButton: 'btn btn-flat-danger ml-50',
                    confirmButton: 'btn btn-warning mr-50',
                  },
                  buttonsStyling: false,
                }).then(result => {
                  if (result.value) {
                    navigator.clipboard.writeText(newPassword)
                    Vue.swal({
                      icon: 'success',
                      title: root.$t('copied'),
                      customClass: {
                        confirmButton: 'btn btn-success',
                      },
                    })
                  }
                })
              })
              .catch(() => {
                toastError({
                  title: 'messagesList.error',
                  content: 'myAccount.paymentPassword.updateError',
                })
              })
              .finally(() => {
                this.$bvModal.hide('modal-api-loading')
              })
          }
        })
    }
    return {
      canResetPaymentPassword,
      handleResetPaymentPassword,
    }
  },
}
</script>
<style lang="">

</style>
